import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/tailwind/advanced-editor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogContent"] */ "/vercel/path0/apps/web/components/tailwind/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/tailwind/ui/menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/vercel/path0/apps/web/components/tailwind/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.4_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/app-dir/link.js");
